import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useIsOrganizationOwner } from '@modules-deprecated/app/organization/hooks/useIsOrganizationOwner'
import { useUmbrella } from '@modules-deprecated/app/umbrellas'

import { Scope } from '../../../../../enums/scope'
import { isAuthorized } from '../../../../../utils/isAuthorized'

export const useShouldShowAccountingBasis = () => {
  const { organization } = useUserOrganization()
  const { umbrella } = useUmbrella()
  const { isOrganizationOwner } = useIsOrganizationOwner()

  const canChangeAccountingBasis = isAuthorized(Scope.SettingAccountingBasis)
  const isOwnerOrMember = !!umbrella || isOrganizationOwner
  const isGermanOrganization = organization?.countryId === 'DE'

  return { shouldShowAccountingBasis: canChangeAccountingBasis && isOwnerOrMember && !isGermanOrganization }
}
